<template>
<v-container fluid class="px-4 py-0">
  <v-layout row>

    <v-flex xs12 sm6 md4 lg4 xl2>
      <gateway-selector solo v-model="selectedGateway" :label="$t('device.filter_by_gateway')"></gateway-selector>
    </v-flex>

    <v-flex xs12 sm6 md4 lg4 xl2 class="px-4">
      <v-slider v-model="edgeLevel" always-dirty thumb-label="always" color="secondary" ticks min="1" max="5" class="mx-4" :disabled="refreshing"></v-slider>
    </v-flex>

    <v-spacer></v-spacer>

    <v-btn fab small color="primary" v-model="isOptimized" @click="isOptimized=!isOptimized" :disabled="refreshing">
      <v-icon>merge_type</v-icon>
      <v-icon>gesture</v-icon>
    </v-btn>

    <v-btn fab small color="secondary" @click="$emit('refresh')" :disabled="refreshing">
      <v-icon>refresh</v-icon>
    </v-btn>

  </v-layout>
</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import GatewaySelector from '@/components/gateway/GatewaySelector'

export default {
  name: 'RouteAnalysisPanel',
  mixins: [UserAuth],
  components: {
    'gateway-selector': GatewaySelector
  },
  props: ['mac', 'optimize', 'level', 'refreshing'],
  computed: {
    selectedGateway: {
      get() {
        return this.mac;
      },
      set(val) {
        this.$emit('update:mac', val);
      }
    },
    isOptimized: {
      get() {
        return this.optimize;
      },
      set(val) {
        this.$emit('update:optimize', val);
      }
    },
    edgeLevel: {
      get() {
        return this.level;
      },
      set(val) {
        this.$emit('update:level', val);
      }
    }
  },
  mounted() {
    this.selectedGateway = this.searchGateway || Object.keys(this.userMacInfo).find(m => m);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/juice/RouteAnalysisPanel.vue